import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import player_sprite from "../assets/player_sprite.png";
import skill_tree_sprite from "../assets/skill_tree_sprite.png";
import quest_logs_sprite from "../assets/quest_logs_sprite.png";
import link_sprite from "../assets/link_sprite.png";
import "../styles/nav.css";
import MyStats from "../myStats/MyStats.js";
import { RpgModeContext } from "../RpgModeContext.js";

export default function Nav() {
  const location = useLocation();
  const { rpgMode } = useContext(RpgModeContext);

  const getNavPositionClass = () => {
    switch (location.pathname) {
      case "/about":
        return "nav-about";
      case "/skills":
        return "nav-skills";
      case "/projects":
        return "nav-projects";
      case "/contact":
        return "nav-contact";
      default:
        return "";
    }
  };

  const NavPositionClass = getNavPositionClass();

  const isCurrentPage = (navClass) => {
    return navClass === NavPositionClass;
  };

  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (event) => {
      if (location.pathname !== "/") {
        navigate("/", { replace: true });
      } else {
        window.history.back();
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [location.pathname, navigate]);

  const renderNavLink = (to, imgSrc, altText, navClass, label) => {
    const isCurrent = isCurrentPage(navClass);
    const linkClass = isCurrent ? "nav-link current" : "nav-link";

    const handleClick = (e) => {
      e.preventDefault();
      if (isCurrent) {
        navigate("/", { replace: true });
      } else {
        navigate(to, { replace: true });
      }
    };

    return (
      <div className="nav-item">
        <a href={to} className={linkClass} onClick={handleClick}>
          <img src={imgSrc} alt={altText} />
        </a>
        <span className={`nav-label ${isCurrent ? "active" : ""}`}>
          {label}
        </span>
      </div>
    );
  };

  return (
    <div>
      <div className="ui-bar">
        <MyStats />
        <nav className="nav">
          {renderNavLink(
            "/about",
            player_sprite,
            "player sprite",
            "nav-about",
            rpgMode ? "PLAYER" : "ABOUT ME"
          )}
          {renderNavLink(
            "/skills",
            skill_tree_sprite,
            "skill tree sprite",
            "nav-skills",
            rpgMode ? "SKILL TREE" : "SKILLS"
          )}
          {renderNavLink(
            "/projects",
            quest_logs_sprite,
            "quest logs sprite",
            "nav-projects",
            rpgMode ? "QUEST LOG" : "PROJECTS"
          )}
          {renderNavLink(
            "/contact",
            link_sprite,
            "link sprite",
            "nav-contact",
            rpgMode ? "LINK" : "CONTACT"
          )}
        </nav>
      </div>
    </div>
  );
}
